import { CheckboxField, Link } from '@/components/ui'
import { getCourtoisTermsUrl } from '@/services/courtois'
import { cn } from '@/utils'

interface TermsCheckboxProps {
  value?: boolean
  setFieldValue: (name: string, value?: boolean) => void
  isMutating?: boolean
  className?: string
}

export const TermsCheckbox = ({
  value,
  setFieldValue,
  isMutating,
  className,
}: TermsCheckboxProps) => (
  <CheckboxField
    id="terms"
    label={
      <>
        I agree to the{' '}
        <Link
          href={getCourtoisTermsUrl()}
          onClick={(e) => e.stopPropagation()}
          size="xs"
          newTab
        >
          Terms and Conditions
        </Link>
      </>
    }
    checked={value}
    onCheckedChange={(checked) => {
      setFieldValue('terms', checked)
    }}
    disabled={isMutating}
    required
    className={cn(className)}
  />
)
